import { BuildStatus } from '../enums/build-status.enum';

export class RepositoryState {
    repositoryId: string;
    ownerId: number;
    repositoryName: string;
    buildStatus: BuildStatus;
    urlToLogFile: string;
    commitId: string;
    createAt: Date;
    builtAt: Date;
}

export class RepositoryEntity {
    repositoryId: string;
    ownerId: number;
    repositoryName: string;
    createAt: Date;
}

export class CredentialPayload {
    Username: string;
    Password: string;
}

export class RepositoryPayload {
    name: string;
    moduleExampleId: string;
    moduleId: string;
}

export class ModuleRepositoryExample {
    id: string;
    name: string;
    repositoryName: string;
}

export interface ModuleBuilderRepository {
    repository: RepositoryEntity;
    states: RepositoryState;
}
